export default __webpack_public_path__ + "static/media/sounds/trcFluencyReminder.mp3";